import React, { useState } from "react";
import "./Estimation.css";
import downArrow from "../../../shared/assets/icons/downArrow.png";
import backIcon from '../../../shared/assets/icons/back.png';
import bellIcon from '../../../shared/assets/icons/bell.png';
import micIcon from '../../../shared/assets/icons/mic.png';
import { useNavigate, useParams } from 'react-router-dom';

const Estimation = ({ onBack }) => {
  const [expanded, setExpanded] = useState({
    spareParts: false,
    labour: false,
    workDone: false,
    photos: false,
  });

  const toggleSection = (section) => {
    setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="container">
      <header className="mobile-header">
        <div className="back-button" onClick={() => navigate(`/maintenancedetails/${id}`)}>
          <img src={backIcon} alt="Back" className="icon back-icon" />
        </div>
        <div className="main-mobile-header">
          <h2 className="main-title">Estimation</h2>
          <p className="subtext">#1234567 | Abcd Technologies | Air Conditioner</p>
        </div>

        <div className="header-icons">
          <img src={bellIcon} alt="Notifications" className='notification-icon' />
        </div>
      </header>


      <div className="card card-first">
        <div className="card-header" onClick={() => toggleExpand("technician")}>
          Technician <span>{expanded === "technician" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
        </div>
        {expanded === "technician" && (
          <div className="card-content">
            <br />
            <p className="technician-info">
              Abcd Technologies
              <span className="technician-id">#1234567</span>
            </p>

            <hr className="divider" />

            <p>John Doe</p>
            <br />
            <p>+91 8741497788</p>
            <br />
            <p>johndoe@gmail.com</p>
            <br />
            <p>258 Street, Palarivattom, Ernakulam, Kerala, India</p>
          </div>
        )}
      </div>

      <div className="card card-subsequent">
        <div className="card-header" onClick={() => toggleExpand("spare")}>
          Spare Parts
          <div className="spare-total-container">

            <span className="spare-total-label">Total</span>
            <span className="spare-total-amount">₹ 44,000.00</span>
          </div>
          <span className="arrow-margin">{expanded === "spare" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
        </div>
        {expanded === "spare" && (
          <div className="card-content">
            <div className="spare-parts-table">
              <br />
              <div className="row header">
                <span>Cost</span>
                <span>Quantity</span>
                <span>Value</span>
              </div>
              <div className="row header">
                <span>Thermistor & si</span>
                <span>1 No's</span>
                <span>₹ 22,000.00</span>
              </div>
              <div className="row header">
                <span>Condenser Coil</span>
                <span>1 No's</span>
                <span>₹ 22,000.00</span>
              </div>
              <hr className="divider" />
              <div className="row header">
                <h3>Total</h3>
                <span></span>
                <h3>₹ 44,000.00</h3>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="card card-subsequent">
        <div className="card-header" onClick={() => toggleExpand("labour")}>
          Labour  <div className="labour-total-container">

            <span className="labour-total-label">Total</span>
            <span className="labour-total-amount">₹ 24.36</span>
          </div>
          <span className="arrow-margin">{expanded === "spare" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
        </div>
        {expanded === "labour" && (
          <div className="card-content">
            <div className="spare-parts-table">
              <br />
              <div className="row header">
                <span>Estimated Time:</span>
                <span>Cost</span>
              </div>
              <div className="row header">
                <span>16:00:00</span>
                <span> ₹ 24.36</span>
              </div>
              <hr className="divider" />
              <div className="row header">
                <h3>Total</h3>
                <span></span>
                <h3>₹ 24.36</h3>
              </div>
            </div>

          </div>
        )}
      </div>
      <br />
      <hr className="divider-margin" />
      <div className="grand-total-section">
        <h3 className="grand-total-left">Grand Total:</h3>
        <h3 className="grand-total-right">₹ 44,024.36</h3>
      </div>
      <hr className="divider-margin" />

      <br />




      <button className="submit-button" onClick={() => navigate(`/maintenancedetails/${id}`)}>Submit</button>
    </div>
  );
};


export default Estimation;
